import React, { useEffect } from 'react';
import Button from "react-bootstrap/Button";
import classes from "./TopDrawer.module.css";
import Backdrop from "../Backdrop/Backdrop";

const TopDrawer = ({ onClose, children, anyTopDrawerOpen, open}) => {
    useEffect(() => {
        let scrollbarWidth = (window.innerWidth - document.documentElement.clientWidth) + "px";
        if (anyTopDrawerOpen) {
            // Disable background scrolling
            document.body.style.overflow = 'hidden';
            document.body.style.marginRight = scrollbarWidth;
        } else {
            // Enable background scrolling
            document.body.style.overflow = '';
            document.body.style.marginRight = "0px";
        }

        return () => {
            // Cleanup style changes on unmount or when modal is closed
            document.body.style.overflow = '';
        };
    }, [anyTopDrawerOpen]);

    let attachedClasses = ["PresetModal", classes.TopDrawer, classes.Close];
    if (open) {
        attachedClasses = ["PresetModal", classes.TopDrawer, classes.Open];
    }
    return (
        <React.Fragment>
            <Backdrop show={open} clicked={onClose}/>
            <div className={attachedClasses.join(' ')}>
                <div >
                    {children}
                    <div style={{width: "100%", display: "flex", justifyContent: "right", gap: "8px"}}>
                        <Button
                            variant="danger"
                            className="preset-modal-cancel-button"
                            style={{margin: 10}}
                            onClick={() => {
                                onClose();
                            }}
                        >
                            Close
                        </Button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default TopDrawer;
